import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { checkLogin } from '../../slices/auth'

export default function CheckLogin() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { user: currentUser } = useSelector((state) => state.auth);

    useEffect(() => {
        let ignore = false
        if (!ignore) {
            dispatch(checkLogin())
        }
        return () => {
            ignore = true;
        };        
    }, [])


    if (!(currentUser && currentUser.authenticated)) {
        if (!window.location.pathname.includes('login')) {
            navigate('/login')
        }
    }

    return (
        <></>
    )
}
